/**
 * Dev-only console diagnostics for FastShift trace sampling, so the effect of the
 * `fastshift_portal_tracing` dynamic config can be followed request by request.
 *
 * `process.env['MODE']` is inlined at build time and is only `'dev'` under `yarn dev`/`yarn serve`,
 * so this is a literal `false` in staging and production bundles. The bundler then strips every
 * call site below, argument expressions included, and nothing here can reach a customer console.
 */
export const IS_FASTSHIFT_TRACE_LOGGING_ENABLED = process.env['MODE'] === 'dev';

const LOG_PREFIX = '[fastshift-tracing]';

const loggedKeys = new Set<string>();

/** Logs on every call. Use for per-request decisions. */
export function logFastshiftTrace(message: string, ...detail: unknown[]): void {
	if (!IS_FASTSHIFT_TRACE_LOGGING_ENABLED) {
		return;
	}

	console.log(`${LOG_PREFIX} ${message}`, ...detail);
}

/**
 * Logs only the first time it is called for a given `key`. Use for facts that are stable for the
 * session — the resolved config — which would otherwise repeat on every request.
 */
export function logFastshiftTraceOnce(key: string, message: string, ...detail: unknown[]): void {
	if (!IS_FASTSHIFT_TRACE_LOGGING_ENABLED || loggedKeys.has(key)) {
		return;
	}

	loggedKeys.add(key);

	logFastshiftTrace(message, ...detail);
}

/** Test-only: clears the `logFastshiftTraceOnce` history. */
export function __resetFastshiftTraceDevLogForTests(): void {
	loggedKeys.clear();
}
